import classNames from 'classnames';

import CollapsibleItem from '../CollapsibleItem/CollapsibleItem';

import styles from './Faq.module.scss';

const Faq = ({ items = [], className }) => {
  return (
    <div
      className={classNames(styles.wrap, className)}
      itemScope
      itemType='https://schema.org/FAQPage'
    >
      <div className={styles.inner}>
        <div className={styles.list}>
          {items?.sections?.map((item, key) => (
            <CollapsibleItem
              toggle={item?.title}
              content={item?.content}
              key={key}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Faq;
